/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { CellPresenterBase } from "./CellPresenterBase";
import { CellModel } from "./CellModel";
import { TextCellModel } from "./TextCellModel";
import { ContentCellModelHelper } from "./ContentCellModelHelper";
import { TypeRegistrar, markType } from "igniteui-react-core";
/**
 * @hidden
 */
var TextHeaderCellPresenter = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(TextHeaderCellPresenter, _super);
    function TextHeaderCellPresenter(a) {
        return _super.call(this, a) || this;
    }
    Object.defineProperty(TextHeaderCellPresenter.prototype, "d", {
        get: function () {
            return this.a;
        },
        enumerable: true,
        configurable: true
    });
    TextHeaderCellPresenter.prototype.b = function (a) {
        _super.prototype.b.call(this, a);
        var b = a;
        if (a.as) {
            if (a.ax(TextCellModel.kw)) {
                b.ir = b.ky;
                this.d.cm.setRawText(b.ir);
            }
            if (a.ax(CellModel.f7)) {
                var c = this.d.cg.l;
                if (a.bb) {
                    this.d.cg.l = false;
                }
                this.d.cg.b = a.m;
                if (a.bb) {
                    this.d.cg.l = c;
                }
            }
            if (a.ax(CellModel.f8)) {
                var d = this.d.cg.l;
                if (a.bb) {
                    this.d.cg.l = false;
                }
                this.d.cg.a0 = a.kr;
                if (a.bb) {
                    this.d.cg.l = d;
                }
            }
            if (a.aw("IsColumnOptionsEnabled")) {
                var e = b.k7;
                if (e) {
                    e = this.e();
                }
                this.d.ci = e;
                this.d.ck.setRawStyleProperty("display", e ? "inline-block" : "none");
                this.a.bx(a.gg, (a.fp + a.fr + a.eb + a.ee));
            }
            if (a.aw("SortIndicatorStyle")) {
                this.d.cg.f = b.k5;
            }
            if (a.aw("ColumnOptionsIconAlignment")) {
                this.d.ca = b.k1;
            }
            if (a.aw("ColumnOptionsIconBehavior")) {
                this.d.cc = b.k3;
            }
            if (a.aw("ColumnOptionsIconColor")) {
                this.d.ce.bp = b.lj;
            }
            ContentCellModelHelper.a(this.a.w, b, this.a.z, this.d.cm, this.a);
        }
    };
    TextHeaderCellPresenter.prototype.e = function () {
        return TypeRegistrar.isRegistered("IgxGridColumnOptionsComponent");
    };
    TextHeaderCellPresenter.$t = markType(TextHeaderCellPresenter, 'TextHeaderCellPresenter', CellPresenterBase.$);
    return TextHeaderCellPresenter;
}(CellPresenterBase));
export { TextHeaderCellPresenter };
//# sourceMappingURL=TextHeaderCellPresenter.js.map
